import { getUserData } from "../../../config/common";
import { BoothOne, BoothThree, BoothTwo } from "./Booths";
export var body = {
    userData: getUserData(),
    background: "https://assets.swoogo.com/uploads/full/2178458-636911afbed02.jpg",
    links: [
        {
            width: "12%",
            height: "20%",
            top: "42%",
            left: "1%",
            label: "CyberAngel",
            href: BoothThree.location
        },
        {
            width: "12%",
            height: "20%",
            top: "42%",
            left: "14%",
            label: "Crowdstrike",
            href: BoothThree.location
        },
        {
            width: "12%",
            height: "18%",
            top: "46%",
            left: "76%",
            label: "Algosec",
            href: BoothThree.location
        },
        {
            width: "12%",
            height: "18%",
            top: "46%",
            left: "88%",
            label: "Reliaquest",
            href: BoothThree.location
        },
        {
            width: "14%",
            height: "23%",
            top: "34%",
            left: "58.5%",
            label: "BlueVoyant",
            href: BoothThree.location
        },
        {
            width: "14%",
            height: "23%",
            top: "34%",
            left: "43.3%",
            label: "SureCloud",
            href: BoothThree.location
        },
        {
            width: "14%",
            height: "23%",
            top: "34%",
            left: "28%",
            label: "Security Scorecard",
            href: BoothThree.location
        },
        {
            width: "16%",
            height: "26%",
            left: "23.1%",
            top: "5%",
            label: "Huawei",
            href: BoothTwo.location
        },
        {
            width: "16%",
            height: "26%",
            left: "61.3%",
            top: "5%",
            label: "IBM",
            href: BoothTwo.location
        },
        {
            width: "18%",
            height: "29%",
            left: "41.1%",
            top: "3%",
            label: "KPMG",
            href: BoothOne.location
        },
        {
            width: "8.2%",
            height: "15.7%",
            left: "46%",
            top: "82.6%",
            label: "Back to Atrium",
            href: "/Atrium"
        }
    ],
    name: "Exibition Hall"
};
export var location = "/Exibition-Hall";
